<template>
  <!--  记功记账考勤表-->
  <div class="attendance">
    <van-sticky>
      <van-cell :border="false" title="统计时间" is-link :value="timeName" @click="popupShow = true"/>
      <van-cell :border="false" title="统计类别" is-link :value="countTypeName" @click="typeShow"/>
    </van-sticky>

    <div v-if="list.length === 0 && !incomeListLoading" class="noContent">
      <img src="../../../assets/images/train/empty_peixun.png">
      <div class="blank-tip">暂无内容</div>
    </div>
    <div v-else class="list-content">
      <div v-for="(item,index) in list" :key="index">
        <div class="date">
          {{ item.studyDate }}
        </div>
        <div class="content" :class="dataIndex % 2==1 ? 'blue':''" v-for="(data,dataIndex) in item.details"
             :key="dataIndex">
          <div class="title">
            课程：{{ data.name }}
          </div>
          <div class="info">
            <van-col v-if="countType[0] === '0' || countType.indexOf('1')>-1" span="12">学习次数 <span>{{
                data.studyCount
              }}</span></van-col>
            <van-col v-if="countType[0] === '0' || countType.indexOf('3')>-1" span="12">学习进度 <span>{{
                data.studyRate
              }}%</span></van-col>
            <van-col v-if="countType[0] === '0' || countType.indexOf('2')>-1" span="12">学习时长 <span>{{
                data.totalStudyDurationStr
              }}</span></van-col>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="popupShow" position="bottom">
      <van-picker
        title="标题"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="onChange"
      />
    </van-popup>


    <van-popup v-model="countTypeShow" position="bottom">
      <div class="van-picker">
        <div class="van-picker__toolbar">
          <button type="button" class="van-picker__cancel" @click="cancelCountType">取消</button>
          <div class="van-ellipsis van-picker__title">统计类别</div>
          <button type="button" class="van-picker__confirm" @click="confirmCountType">确认</button>
        </div>
        <div class="van-picker__columns">
          <!--        <div class="van-picker__mask count-type" style="background-size: 100% 110px;">-->
          <van-checkbox-group v-model="result" @change="countTypeChange">
            <van-cell-group :border="false">
              <van-cell
                v-for="(item, index) in countTypeList"
                :title="item.name"
                :key="index"
              >
                <template #right-icon>
                  <van-checkbox :name="item.id" ref="checkboxes"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <!--        </div>-->
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { studyReport } from '@api/injury'

export default {
  name: 'attendance',
  data () {
    return {
      countTypeName: '全部',
      countType: ['0'],
      result: ['0'],
      countTypeList: [
        { id: '0', name: '全部' },
        { id: '1', name: '学习次数' },
        { id: '2', name: '学习时长' },
        { id: '3', name: '学习进度' }
      ],
      showPopover: false,
      list: [],
      incomeListLoading: false,
      // 0-全部；1-近7天；2-近1月；3-近3月
      timeType: 1,
      timeName: '近7天',
      columns: ['全部', '近7天', '近1月', '近3月'],
      popupShow: false,
      countTypeShow: false,
      totalStudyCount: '',
      totalStudyDuration: ''
    }
  },
  created () {
    this.projectId = this.$route.query.projectId
    this.contentList()
  },
  mounted () {
  },
  methods: {

    // 选择统计类型
    typeShow () {
      this.result = this.countType
      this.countTypeShow = true
    },

    // 关闭选择统计类型
    cancelCountType () {
      this.countTypeShow = false
    },

    // 确认选择统计类型
    confirmCountType () {
      if (this.result.length === 0) {
        this.$toastMsg('请至少选择一个类型')
      } else {
        let name = ''
        this.countType = this.result
        if (this.result.length === 3) {
          this.countTypeName = '全部'
        } else {
          for (let i = 0; i < this.countTypeList.length; i++) {
            if (this.result.indexOf(this.countTypeList[i].id) > -1) {
              if (name !== '') {
                name += '，'
              }
              name += this.countTypeList[i].name
            }
          }
          this.countTypeName = name
        }
        this.countTypeShow = false
      }
    },
    // 统计类型变动
    countTypeChange (e) {
      console.log('统计类型变动', e)
      if (e.length > 1) {
        if (e[e.length - 1] === '0') {
          this.result = ['0']
        } else {
          if (e[0] === '0') {
            this.result = [e[1]]
          }
        }
      }
    },

    // 确认
    onConfirm (value, index) {
      this.timeType = index
      this.timeName = value
      this.onSearch()
      this.popupShow = false
    },
    onChange (picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)
    },
    onCancel () {
      this.popupShow = false
      console.log('取消')
    },

    // 搜索
    onSearch () {
      this.list = []
      this.contentList()
    },

    // 获取列表内容
    contentList () {
      this.incomeListLoading = true
      studyReport({
        projectId: this.projectId,
        timeType: this.timeType
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          this.list = res.data.data.list
          this.totalStudyCount = res.data.data.totalStudyCount
          this.totalStudyDuration = res.data.data.totalStudyDuration
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/mixin";

.popover-txt {
  font-size: 14px;
  padding: 7px 12px;
  color: #FFFFFF;
  //background-color: #1488f5;
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-sticky {
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.05);
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-sticky--fixed {
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.05);
}

//.van-popover--dark {
//  //noinspection CssInvalidPseudoSelector
//  ::v-deep .van-popover__arrow {
//    color: #1488f5 !important;
//  }
//}

.attendance {
  padding-bottom: 30px;
  font-size: 16px;

  .van-picker__columns {
    position: relative;
    //height: auto;
    height: 240px;
    width: auto;

    .van-checkbox-group {
      width: 100%;
      margin: auto;
      padding: 0 15px;

      .van-cell {
        padding: 5px 10px;
      }

      .van-cell__title {
        margin: auto;
      }

      .van-checkbox {
        padding: 5px;
      }
    }
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-cell {
    display: inline-flex;
    font-size: 15px !important;
    padding: 10px;
    line-height: normal;

    .van-cell__value {
      min-width: 70%;
      text-align: right;
      color: #333;

      span {
        display: inline-block;
        word-break: break-all;
      }
    }
  }

  .list-content {
    margin-bottom: 60px;
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.05);

    .date {
      font-size: 14px;
      padding: 10px;
    }

    .content {
      line-height: 28px;
      display: flow-root;
      padding: 10px;
      background-color: #FFFFFF;
      font-size: 14px;

      .title {
        line-height: normal;
        font-weight: bold;
        margin-bottom: 6px;
        //white-space: nowrap;
        //overflow: hidden;
        //text-overflow: ellipsis;
      }

      .info {
        color: #999999FF;

        span {
          color: #333333FF;
        }
      }
    }

    .blue {
      background-color: #F2F8FEFF;
    }

  }

}
</style>
